<% var component = new Anvil.models.components.File(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col">
	<input <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
	<div class="input-group">
		<div class="form-control">
			<input type="file" class="d-none" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
			<label class="custom-file-label" for="<%= form.name %>_<%= field.name %>" data-browse="Tallózás">Válassza ki a fájlt</label>
		</div>
		<label class="btn btn-dark" for="<%= form.name %>_<%= field.name %>">Tallózás</label>
	</div>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<div class="input-group">
			<div class="form-control">
				<input type="file" class="d-none" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %> />
				<label class="custom-file-label" for="<%= form.name %>_<%= field.name %>" data-browse="Tallózás">Válassza ki a fájlt</label>
			</div>
			<label class="btn btn-dark" for="<%= form.name %>_<%= field.name %>">Tallózás</label>
		</div>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
